import ApiService from './ApiService';

export default {
  getList() {
    return ApiService.get('/configs');
  },
  updateConfig(data) {
    return ApiService.put('/config', data);
  },
}
